import { render, staticRenderFns } from "./BulkMilestoneDialog.vue?vue&type=template&id=54fbac8a&scoped=true&"
import script from "./BulkMilestoneDialog.vue?vue&type=script&lang=js&"
export * from "./BulkMilestoneDialog.vue?vue&type=script&lang=js&"
import style0 from "./BulkMilestoneDialog.vue?vue&type=style&index=0&id=54fbac8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbac8a",
  null
  
)

export default component.exports